var React = require('react');

function MailIconInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#333"},[React.createElement("path",{"d":"m1 1h18v13h-18z","strokeWidth":"2","key":0}),React.createElement("path",{"d":"m1 1 7.57287 7.71311c.78391.79843 2.07033.79843 2.85423 0l7.5729-7.71311","key":1})]));
}

MailIconInline.defaultProps = {"fill":"none","height":"15","viewBox":"0 0 20 15","width":"20"};

module.exports = MailIconInline;

MailIconInline.default = MailIconInline;
